export default __webpack_public_path__ + "static/media/handicap.7642e8a3.svg";